<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium" v-if="revenueBeta">Reglas de envío</v-toolbar-title>
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium" v-else>
            <v-row align="center" justify="start" no-gutters>
              <router-link class="subtitle-1 routerLink font-weight-medium" :to="{name: 'Receivables'}">Cuentas por cobrar</router-link>
              <v-icon class="mx-1 pt-1" color="secondary">mdi-chevron-right</v-icon>
              <span class="subtitle-1 font-weight-medium d-inline-block text-truncate">Recordatorios de pago</span>
            </v-row>
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items v-if="editableRules.length">
            <v-row align="center" justify="center" class="mr-1">
              <span class="mr-4 d-block body-2 text--primary">Activar los recordatorios automáticos</span>
              <v-switch v-model="sendPaymentsReminders" @change="updateAccount" :disabled="!editableRules.length" class="py-0 my-0" :width="32" :height="18" hide-details />
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="py-8 background card-dots overflow-y-auto" style="height: calc(100vh - 170px)">
          <v-row align="center" justify="center" v-if="$store.state.reminders.retrieveLoader">
            <v-col cols="12" lg="7" md="9">
              <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line" />
            </v-col>
          </v-row>
          <v-row class="v-card-timeline" align="center" justify="center" v-else>
            <v-col cols="12" lg="7" md="9" v-for="(d, i) in editableRules.filter(e => e.scheme === 'B')" :key="`${i}-before-due-rules`">
              <v-card :class="{ 'indigo lighten-5': activeReminder === d.id }" @click="newReminder=d, dialogNewReminder=true" :ref="`${d.id}-rule`" :ripple="false">
                <v-toolbar color="transparent" flat height="55">
                  <v-list-item-avatar size="32" color="background"><v-icon color="primary" size="18">mdi-email-outline</v-icon></v-list-item-avatar>
                  <v-toolbar-title class="text--secondary subtitle-2 font-weight-medium">
                    {{d.days}} día<template v-if="d.days > 1">s</template> <template v-if="d.scheme === 'B'">antes</template><template v-else>después</template> del vencimiento del pago
                  </v-toolbar-title>
                  <v-spacer />
                  <v-toolbar-items>
                    <v-row align="center" justify="center" class="mr-1">
                      <v-btn @click.stop="deleteRule(d)" color="red" icon :ripple="false" small><v-icon size="18">mdi-trash-can-outline</v-icon></v-btn>
                    </v-row>
                  </v-toolbar-items>
                </v-toolbar>
                <v-divider />
                <v-card-text>
                  <span>Asunto:</span> <span class="text--primary">{{d.template.subject}}</span>
                  <v-divider class="my-2" />
                  <span class="text--primary">{{d.template.message}}</span>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col class="text-center" cols="12" lg="7" md="9">
              <v-chip class="v-chip-timeline-element" outlined small text-color="primary"><v-icon left size="18">mdi-calendar-alert-outline</v-icon>Vencimiento del pago</v-chip>
            </v-col>
            <v-col cols="12" lg="7" md="9" v-for="(d, i) in editableRules.filter(e => e.scheme === 'A')" :key="`${i}-after-due-rules`">
              <v-card class="v-card-timeline" :class="{ 'indigo lighten-5': activeReminder === d.id }" @click="newReminder=d, dialogNewReminder=true" :ref="`${d.id}-rule`" :ripple="false">
                <v-toolbar color="transparent" flat height="55">
                  <v-list-item-avatar size="32" color="background"><v-icon color="primary" size="18">mdi-email-outline</v-icon></v-list-item-avatar>
                  <v-toolbar-title class="text--secondary subtitle-2 font-weight-medium">
                    {{d.days}} día<template v-if="d.days > 1">s</template> <template v-if="d.scheme === 'B'">antes</template><template v-else>después</template> del vencimiento del pago
                  </v-toolbar-title>
                  <v-spacer />
                  <v-toolbar-items>
                    <v-row align="center" justify="center" class="mr-1">
                      <v-btn @click.stop="deleteRule(d)" color="red" icon :ripple="false" small><v-icon size="18">mdi-trash-can-outline</v-icon></v-btn>
                    </v-row>
                  </v-toolbar-items>
                </v-toolbar>
                <v-divider />
                <v-card-text>
                  <span>Asunto:</span> <span class="text--primary">{{d.template.subject}}</span>
                  <v-divider class="my-2" />
                  <span class="text--primary">{{d.template.message}}</span>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col class="text-center" cols="12" lg="7" md="9">
              <v-btn color="primary" @click="dialogNewReminder=true" dark :disabled="editableRules.length >= 5" fab small :ripple="false"><v-icon dark size="22">mdi-plus</v-icon></v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>

    <!-- dialog reminder message -->
    <v-dialog v-model="dialogNewReminder" no-click-animation persistent scrollable width="1200">
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">{{newReminder.id ? 'Editar recordatorio automático' : 'Recordatorio automático'}}</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-btn class="ml-3" @click="dialogNewReminder=false, resetNewReminder()" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>

        <v-divider />

        <v-card-text class="py-0 px-3" style="height: calc(100vh - 225px); overflow-y: auto;">
          <v-row class="fill-height">
            <v-col cols="5" class="px-0 fill-height background overflow-y-auto">
              <v-list class="transparent">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="mx-1 mb-2 text--secondary font-weight-medium"><v-icon class="mt-n1" color="secondary" size="20">mdi-clock-outline</v-icon> Programación del envío</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-row align="center" no-gutters>
                        <div class="mx-1" style="width:60px">
                          <v-text-field v-model="$v.newReminder.days.$model" :error="$v.newReminder.days.$error" background-color="white" dense hide-details outlined placeholder="1" required reverse single-line />
                        </div>
                        <span class="px-2 mx-1 defaultGrey text--secondary" style="height:38px; line-height:38px;border-radius:4px;">días</span>
                        <div class="mx-1" style="width:140px">
                          <v-select v-model="newReminder.scheme" :items="schemes" single-line :v-ripple="false"  item-text="text" item-value="value" hide-details dense height="30" outlined background-color="white" />
                        </div>
                        <span class="px-2 defaultGrey text--secondary" style="height:38px; line-height:38px; border-radius:4px;">del vencimiento del pago</span>
                      </v-row>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-divider class="mx-5 mt-5 mb-6" />

                <v-list-item>
                  <v-list-item-content class="py-1">
                    <v-list-item-title class="mx-1 text--secondary font-weight-medium">Asunto</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-text-field ref="subject" v-model.trim="$v.newReminder.template.subject.$model" :error-messages="subjectErrors" background-color="white" outlined required single-line dense maxlength="150" counter="150" placeholder="Escribe un asunto para el email" persistent-hint>
                        <template v-slot:append>
                          <token-menu field="subject" compact @select="setToken('subject', $event)" />
                        </template>
                      </v-text-field>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-title class="mx-1 text--secondary font-weight-medium">Mensaje</v-list-item-title>
                  <v-list-item-subtitle class="text-right">
                    <token-menu field="message" @select="setToken('message', $event)" />
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content class="py-1">
                    <v-textarea v-model.trim="$v.newReminder.template.message.$model" :error-messages="messageErrors" background-color="white" auto-grow rows="8" outlined placeholder="Escribe el mensaje del recordatorio" ref="message" />
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>

            <v-divider vertical />

            <v-col class="fill-height overflow-y-auto">
              <v-row class="" align="center" justify="space-between" no-gutters>
                <v-toolbar flat dense class="px-0 align-center" height="48">
                  <v-toolbar-title class="subtitle-2 text--secondary font-weight-medium">Previsualización</v-toolbar-title>

                  <v-spacer />

                  <v-toolbar-items class="align-center">
                    <v-btn-toggle v-model="previewSource" mandatory color="primary" dense>
                      <v-btn outlined :ripple="false" small value="sample">Ejemplo</v-btn>
                      <v-btn outlined :ripple="false" small value="invoice">Factura real</v-btn>
                    </v-btn-toggle>
                  </v-toolbar-items>
                </v-toolbar>
              </v-row>
              <v-row v-if="previewSource === 'invoice'" class="pt-4" justify="center" no-gutters>
                <v-col cols="12" lg="10">
                  <v-autocomplete v-model="previewSelectedInvoice" :items="previewInvoices" :loading="previewInvoicesLoader" :search-input.sync="previewInvoiceSearch" :item-text="previewInvoiceText" item-value="id" return-object no-filter placeholder="Busca una factura por número" no-data-text="No se encontraron facturas" prepend-inner-icon="mdi-magnify" background-color="white" dense hide-details outlined clearable />
                </v-col>
              </v-row>
              <v-row class="py-4" justify="center" no-gutters>
                <v-col cols="12" lg="10">
                  <v-card class="mb-4" outlined>
                    <v-list-item dense>
                      <v-list-item-content>
                        <v-list-item-subtitle class="body-2"><span class="text--secondary">De:</span> <span class="text--primary">{{account.name}}</span></v-list-item-subtitle>
                        <v-list-item-subtitle class="body-2 mt-1"><span class="text--secondary">Asunto:</span> <span class="text--primary font-weight-medium">{{previewSubject || '(sin asunto)'}}</span></v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card>
                  <reminder-invoice-email :instance="previewInstance" action="pay" :template="account.email_template" :color-background="account.color_background" :message="previewMessage" placeholder="Escribe el mensaje del recordatorio" readonly />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn @click="dialogNewReminder=false, resetNewReminder()" outlined color="secondary">Cancelar</v-btn>
          <template v-if="newReminder.id">
            <v-btn @click="updateRule" color="primary" :loading="$store.state.reminders.createLoader">Guardar</v-btn>
          </template>
          <template v-else>
            <v-btn @click="createRule" color="primary" :loading="$store.state.reminders.createLoader">Guardar</v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog reminder message -->
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { numeric, required, maxLength } from 'vuelidate/lib/validators'
import { cloneDeep, debounce, sortBy } from 'lodash'

import CommonTemplates from '@/views/account/CommonTemplates'
import GenericViewMixin from '@/mixins/GenericViewMixin'
import ReminderInvoiceEmail from '@/components/reminders/invoices/Email'
import RevenueBetaMixin from '@/mixins/RevenueBetaMixin'
import TokenMenu from '@/components/reminders/TokenMenu'
import { insertTokenAtCursor, invalidReminderTokens, previewInvoice, renderReminderTemplate } from '@/utils/reminders/tokens'

const validTokens = field => value => !invalidReminderTokens(value, field).length

export default {
  components: {
    CommonTemplates,
    ReminderInvoiceEmail,
    TokenMenu
  },
  mixins: [
    GenericViewMixin,
    RevenueBetaMixin
  ],
  data: () => ({
    activeReminder: null,
    dialogNewReminder: false,
    editableRules: [],
    newReminder: {
      days: null,
      template: {
        kind: 'collection',
        message: '',
        subject: ''
      },
      scheme: 'A'
    },
    previewInvoiceSearch: null,
    previewInvoices: [],
    previewInvoicesLoader: false,
    previewSelectedInvoice: null,
    previewSource: 'sample',
    sendPaymentsReminders: false,
    schemes: [
      { text: 'antes', value: 'B' },
      { text: 'después', value: 'A' }
    ]
  }),
  computed: {
    ...mapState({
      accountsDetail: state => state.accounts.accountsDetail,
      rulesList: state => cloneDeep(state.reminders.rulesList)
    }),
    previewInstance () {
      if (this.previewSource === 'invoice' && this.previewSelectedInvoice) {
        return this.previewSelectedInvoice
      }
      const currency = this.currencies.find(c => c.country === this.account.country && !c.conversion)
      return previewInvoice(currency ? currency.id : undefined)
    },
    previewMessage () {
      return renderReminderTemplate(this.newReminder.template.message, this.previewInstance, { field: 'message' })
    },
    previewSubject () {
      return renderReminderTemplate(this.newReminder.template.subject, this.previewInstance, { field: 'subject' })
    },
    subjectErrors () {
      const v = this.$v.newReminder.template.subject
      if (!v.$dirty) {
        return []
      }
      if (!v.required) {
        return ['Escribe un asunto para el email']
      }
      if (!v.maxLength) {
        return ['Escribe un máximo de 150 caracteres']
      }
      if (!v.validTokens) {
        return [`Variables no permitidas en el asunto: ${invalidReminderTokens(v.$model, 'subject').map(t => `{{${t}}}`).join(', ')}`]
      }
      return []
    },
    messageErrors () {
      const v = this.$v.newReminder.template.message
      if (!v.$dirty) {
        return []
      }
      if (!v.required) {
        return ['Escribe el mensaje del recordatorio']
      }
      if (!v.validTokens) {
        return [`Variables no permitidas en el mensaje: ${invalidReminderTokens(v.$model, 'message').map(t => `{{${t}}}`).join(', ')}`]
      }
      return []
    }
  },
  watch: {
    previewSource (val) {
      if (val === 'invoice' && !this.previewInvoices.length) {
        this.listPreviewInvoices()
      }
    },
    previewInvoiceSearch (val) {
      if (this.previewSelectedInvoice && val === this.previewInvoiceText(this.previewSelectedInvoice)) {
        return
      }
      this.debouncedListPreviewInvoices(val)
    }
  },
  created () {
    this.debouncedListPreviewInvoices = debounce(this.listPreviewInvoices, 400)

    this.$store.dispatch('accounts/RETRIEVE', {
      resource: 'accounts',
      id: this.$store.state.auth.account.id
    })
    .then(() => {
      this.sendPaymentsReminders = this.accountsDetail.send_payments_reminders
    })

    this.$store.dispatch('reminders/LIST', {
      resource: 'reminders/rules',
      query: {
        expand: 'template'
      }
    })
    .then(() => {
      this.editableRules = this.rulesList.map(e => cloneDeep(e))

      this.sortEditableRules()
    })
  },
  methods: {
    createRule () {
      this.$v.newReminder.$touch()

      if (this.$v.newReminder.$invalid) {
        return false
      }

      this.$store.dispatch('reminders/CREATE', {
        resource: 'reminders/templates',
        payload: Object.assign({}, this.newReminder.template, { name: this.newReminder.template.subject })
      })
      .then((response) => {
        this.$store.dispatch('reminders/CREATE', {
          resource: 'reminders/rules',
          payload: Object.assign({}, this.newReminder, { template: response.data.id }),
          query: {
            expand: 'template'
          }
        })
        .then((response) => {
          // mark active reminder
          this.activeReminder = response.data.id
          setTimeout(() => {
            this.activeReminder = null
          }, 2000)

          // add object
          this.editableRules.push(response.data)

          // reset newReminder object
          this.resetNewReminder()

          // close dialog
          this.dialogNewReminder = false

          // sort
          this.sortEditableRules()
        })
        .catch((error) => {
          this.$dialog.message.error(this.parseErrors(error.response.data))
        })
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    },
    deleteRule (rule) {
      this.$dialog.warning({
        title: 'Eliminar recordatorio automático',
        text: '<span class="d-block mb-4">Al confirmar se eliminará este recordatorio de tu organización.</span>',
        actions: [{
          color: 'red',
          text: 'Continuar',
          handle: () => {
            this.$store.dispatch('reminders/DESTROY', {
              resource: 'reminders/templates',
              id: rule.template.id
            })
            .then(() => {
              const i = this.editableRules.findIndex(e => e.id === rule.id)
              this.editableRules.splice(i, 1)

              this.$dialog.message.info('El recordatorio automático se ha eliminado.')
            })
            .catch((error) => {
              this.$dialog.message.error(this.parseErrors(error.response.data))
            })
          }
        }]
      })
    },
    listPreviewInvoices (search) {
      const query = {
        status: 'finalized',
        ordering: '-created',
        page_size: 10
      }
      const number = (search || '').replace(/\D/g, '')
      if (number) {
        query.number = number
      }

      this.previewInvoicesLoader = true
      this.$store.dispatch('invoices/LIST', {
        resource: 'invoices',
        query,
        setState: false,
        loader: false
      })
      .then((response) => {
        this.previewInvoices = response.data.results
      })
      .catch(() => {
        this.previewInvoices = []
      })
      .finally(() => {
        this.previewInvoicesLoader = false
      })
    },
    previewInvoiceText (invoice) {
      if (!invoice) {
        return ''
      }
      return `${invoice.document ? invoice.document.name : 'Factura'} Nº ${invoice.number} · ${invoice.customer ? invoice.customer.name : ''}`
    },
    resetNewReminder () {
      // reset object
      this.newReminder = {
        days: null,
        template: {
          kind: 'collection',
          message: '',
          subject: ''
        },
        scheme: 'A'
      }

      // reset preview
      this.previewSource = 'sample'
      this.previewSelectedInvoice = null

      // reset validator
      this.$v.newReminder.$reset()
    },
    sortEditableRules () {
      if (this.editableRules.length) {
        const beforeExpiration = sortBy(this.editableRules.filter(e => e.scheme === 'B'), (e) => -e.days)
        const afterExpiration = sortBy(this.editableRules.filter(e => e.scheme === 'A'), (e) => e.days)

        this.editableRules = [...beforeExpiration, ...afterExpiration]
      }
    },
    setToken (field, token) {
      const input = this.$refs[field].$refs.input
      const { value, cursor } = insertTokenAtCursor(input, token)

      this.$v.newReminder.template[field].$model = value

      this.$nextTick().then(() => {
        input.focus()
        input.setSelectionRange(cursor, cursor)
      })
    },
    updateAccount () {
      this.$store.dispatch('accounts/UPDATE', {
        resource: 'accounts',
        payload: {
          send_payments_reminders: this.sendPaymentsReminders
        },
        id: this.account.id
      })
      .then(() => {
        this.$dialog.message.info(`Se han ${this.sendPaymentsReminders ? 'habilitado' : 'deshabilitado'} los recordatorios automáticos de pagos`)
      })
      .catch(() => {
        this.$dialog.message.warning(`Error al ${this.sendPaymentsReminders ? 'habilitado' : 'deshabilitado'} los recordatorios automáticos de pagos`)
      })
    },
    updateRule () {
      this.$v.newReminder.$touch()

      if (this.$v.newReminder.$invalid) {
        return false
      }

      this.$store.dispatch('reminders/UPDATE', {
        resource: 'reminders/templates',
        id: this.newReminder.template.id,
        payload: {
          message: this.newReminder.template.message,
          name: this.newReminder.template.subject,
          subject: this.newReminder.template.subject
        }
      })
      .then(() => {
        this.$store.dispatch('reminders/UPDATE', {
          resource: 'reminders/rules',
          id: this.newReminder.id,
          payload: {
            days: this.newReminder.days,
            scheme: this.newReminder.scheme
          },
          query: {
            expand: 'template'
          }
        })
        .then(() => {
          // mark active reminder
          this.activeReminder = this.newReminder.id
          setTimeout(() => {
            this.activeReminder = null
          }, 2000)

          // reset newReminder object
          this.resetNewReminder()

          // close dialog
          this.dialogNewReminder = false

          // sort
          this.sortEditableRules()
        })
        .catch((error) => {
          this.$dialog.message.error(this.parseErrors(error.response.data))
        })
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    }
  },
  validations: {
    newReminder: {
      days: {
        required,
        numeric
      },
      template: {
        subject: {
          required,
          maxLength: maxLength(150),
          validTokens: validTokens('subject')
        },
        message: {
          required,
          validTokens: validTokens('message')
        }
      }
    }
  }
}
</script>
<style>
.card-dots {
  background-image: url('../../assets/appBg--dots.svg');
  background-size: 54px;
  background-repeat: repeat;
}

.v-card-timeline .v-card::after {
  content: "";
  width: 1px;
  height: 25px;
  background-color: #D8E0EA;
  margin: 0 auto;
  position: absolute;
  left: 0;
  right: 0;
}

.v-chip-timeline-element {
  overflow: visible !important;
}

.v-chip-timeline-element::after {
  content: "";
  width: 1px;
  height: 25px;
  background-color: #D8E0EA;
  margin: 0 auto;
  position: absolute;
  left: 0;
  right: 0;
  bottom: -25px;
}
</style>